import axios, { AxiosPromise } from 'axios';

import { ICommodityCondition } from '../../../@types/model/masterData/commodityCondition/commodityCondition';
import { ICommodityConditionUpsert } from '../../../@types/model/masterData/commodityCondition/commodityConditionUpsert';

export default class CommodityConditionHttpService {
    public static getCommodityConditionData() : AxiosPromise<Array<ICommodityCondition>> {
        return axios.get(`${API_URL}/v1/CommodityCondition/GetAllWeb`);
    }

    public static addOrUpdateCommodityCondition(upsert : ICommodityConditionUpsert) : AxiosPromise<ICommodityCondition> {
        return axios.post(`${API_URL}/v1/CommodityCondition/PostCommodityCondition`, upsert);
    }

    public static deleteCommodityCondition(conditionId : number) : AxiosPromise<ICommodityCondition> {
        return axios.delete(`${API_URL}/v1/CommodityCondition/Delete`, {
            params : { conditionId },
        });
    }
}
